module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_home-ee1608479cb507df4d9879b554375509.svg";